import { Alert, Box, Button, Card, Grid, Input, Modal, ModalDialog, Stack, Textarea, Typography } from "@mui/joy";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

function VitrinePersonagensPage() {

    var url = useSelector((state) => state.rpc.servidorUrl)
    var token = useSelector((state) => state.auth.token)
    var [form, setForm] = useState({
        query: "",
        resultados: [],
        error: false,
        loading: false
    })

    var [downloadForm, setDownloadForm] = useState({
        personagem: null,
    })

    const closeDownloadForm = () => {
        setDownloadForm({ ...downloadForm, personagem: null })
    }


    const clearForm = async () => {
        setForm({ ...form, query: "", error: "Limpo..." })
    }



    const search = async () => {
        setForm({ ...form, loading: true, error: false })
        const formData = new FormData();
        const formToSend = {
            action: "CASTOR_BUSCA_PERSONAGENS_CLOSET_RPC",
            runNow: true,
            payload: JSON.stringify({
                query: form.query,
            })
        }

        formData.append("file", null);
        formData.append(
            "data",
            new Blob([JSON.stringify(formToSend)], {
                type: "application/json",
            })
        );

        try {
            var r = await axios.post(url + "/rpc", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${token}`,
                }
            });

            if (r.data.success) {
                setForm({ ...form, resultados: r.data.payload, loading: false, error: "" })
            } else {
                setForm({ ...form, error: r.data.payload, loading: false })
            }


        } catch (error) {
            setForm({ ...form, error: error, loading: false })
            console.log(error)
        }
    }

    React.useEffect(() => {
        search()
    }, []);

    return <Grid container sx={{ padding: 1 }}>
        <Grid xs={12}>
            <Stack spacing={2} direction="row">
                <Input type="text" value={form.query} onChange={(e) => setForm({ ...form, query: e.target.value })} sx={{ width: "500px" }}
                    placeholder="Nome do personagem..." />
                <Button onClick={() => search()}> Buscar </Button>
                <Button onClick={() => clearForm()} color="warning"> Clear </Button>
                <Alert color={form.error ? "danger" : "primary"}>{form.error}</Alert>
            </Stack>
        </Grid>
        <Grid xs={12}>
            <Grid container spacing={2} sx={{ pt: 1 }}>
                {form.resultados.map((img, index) => (
                    <Grid key={index} sx={{ cursor: "pointer" }} onClick={() =>
                        setDownloadForm({ ...downloadForm, personagem: img })
                    }>
                        <Card
                            variant="outlined"
                            sx={{
                                maxWidth: "150px", // Largura máxima da imagem

                                boxShadow: "sm",
                            }}
                        >
                            <Stack>
                                <img
                                    src={url + "/api/public/imgur/" + img.imagemUriP10}
                                    alt={`Imagem ${index}`}
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        display: "block"
                                    }}
                                />

                                <Box
                                    sx={{
                                        width: "150px",
                                        overflow: "hidden",
                                        height: "40px", // Ajusta a altura para duas linhas de texto
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: "13px",
                                            display: "-webkit-box",       // Necessário para line-clamp funcionar
                                            overflow: "hidden",           // Esconde o conteúdo extra
                                            textOverflow: "ellipsis",
                                            WebkitLineClamp: 2,           // Limita a 2 linhas
                                            WebkitBoxOrient: "vertical",  // Orientação para linha vertical
                                            wordBreak: "break-word",      // Quebra palavras longas
                                        }}
                                    >
                                        {img.nome}
                                    </Typography>
                                </Box>
                            </Stack>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Grid>
        <Modal open={downloadForm.personagem != null} onClose={closeDownloadForm}>
            <ModalDialog
                aria-labelledby="basic-modal-dialog-title"
                aria-describedby="basic-modal-dialog-description"
                sx={{ minWidth: 800 }}
            >
                <Grid container>
                    <Grid xs={6} sx={{p:2}}>
                        {console.log(downloadForm.personagem)}
                        {downloadForm.personagem && <img
                            src={url + "/api/public/imgur/" + downloadForm.personagem.imagemUriP25}
                            alt={`Imagem ${downloadForm.personagem.id}`}
                            style={{
                                width: "100%",
                                height: "auto",
                                display: "block"
                            }}
                        />}
                    </Grid>
                    <Grid xs={6}>
                            {downloadForm.personagem && <Stack spacing={2}>
                                <Typography>
                                    Resolução da imagem
                                </Typography>
                                <Link sx={{width: "100%"}} target="_blank" to={url + "/api/public/imgur/" + downloadForm.personagem.imagemUri + "?download=true"}>
                                    <Button sx={{width: "100%"}} color="primary">
                                        Original
                                    </Button>
                                </Link>
                                <Link target="_blank"  to={url + "/api/public/imgur/" + downloadForm.personagem.imagemUriP10 + "?download=true"}>
                                    <Button sx={{width: "100%"}}  color="primary">
                                        p10
                                    </Button>
                                </Link>
                                <Link target="_blank"  to={url + "/api/public/imgur/" + downloadForm.personagem.imagemUriP15 + "?download=true"}>
                                    <Button sx={{width: "100%"}}  color="primary">
                                        p15
                                    </Button>
                                </Link>
                                <Link target="_blank"  to={url + "/api/public/imgur/" + downloadForm.personagem.imagemUriP25 + "?download=true"}>
                                    <Button sx={{width: "100%"}}  color="primary">
                                        p25
                                    </Button>
                                </Link>
                                <Link target="_blank"  to={url + "/api/public/imgur/" + downloadForm.personagem.imagemUriP50 + "?download=true"}>
                                    <Button  sx={{width: "100%"}} color="primary">
                                        p50
                                    </Button>
                                </Link>
                            </Stack>}
                    </Grid>
                </Grid>
            </ModalDialog>
        </Modal>
    </Grid>
}

export default VitrinePersonagensPage;